import { database } from "../Firebase/firebaseConfig"; // Firebase configuration and initialization
import { ref, get, set, push, child, update, onValue } from "firebase/database";
import emailjs from "@emailjs/browser";

let isEmailJsInitialized = false;

const initEmailJs = () => {
  if (!isEmailJsInitialized) {
    emailjs.init("qXdLBSqexGmfoBYAG");
    isEmailJsInitialized = true;
  }
};

// Database paths
const productsRef = ref(database, "products");
const ordersRef = ref(database, "orders");

const warrantyClaimsRef = ref(database , "after-sales-service");
const tagsRef = ref(database, "tags");

/**
 * Fetch all products from Firebase Realtime Database
 * @returns {Promise<Array>} - List of all products
 */
export const getAllProducts = async () => {
  try {
    if (productsRef) {
      const snapshot = await get(productsRef);
      if (snapshot.exists()) {
        const productsData = snapshot.val();
        return Object.keys(productsData).map((key) => ({
          id: key,
          ...productsData[key],
        }));
      } else {
        console.log("No products found");
        return [];
      }
    }
  } catch (error) {
    console.error("Error fetching products:", error);
  }
};

/**
 * Fetch a single product by ID from Firebase Realtime Database
 * @param {string} productId - The ID of the product
 * @returns {Promise<Object|null>} - The product object if found, null if not
 */
export const getProductById = async (productId) => {
  try {
    if (productsRef) {
      const productSnapshot = await get(child(productsRef, productId));
      if (productSnapshot.exists()) {
        return { id: productSnapshot.key, ...productSnapshot.val() };
      } else {
        console.error("No product found with the given ID");
        return null;
      }
    }
  } catch (error) {
    console.error("Error fetching product:", error);
  }
};

/**
 * Fetch all unique tags from the product collection
 * @returns {Promise<Array>} - List of unique tags
 */
export const getAllTags = async () => {
  try {
    const snapshot = await get(productsRef);
    if (snapshot.exists()) {
      const productsData = snapshot.val();
      const tagsSet = new Set();

      Object.values(productsData).forEach((product) => {
        if (product.tags && Array.isArray(product.tags)) {
          product.tags.forEach((tag) => tagsSet.add(tag));
        }
      });

      return Array.from(tagsSet);
    } else {
      console.log("No products found");
      return [];
    }
  } catch (error) {
    console.error("Error fetching tags:", error);
    throw new Error("Could not fetch tags");
  }
};

/**
 * Save an order to Firebase Realtime Database
 * @param {Object} orderData - The order data to save
 * @returns {Promise<Object>} - The saved order reference
 */
export const saveOrder = async (orderData) => {
  try {
    const newOrderRef = push(ordersRef); // Create a new reference for the order
    await set(newOrderRef, orderData); // Save order data to that reference
    console.log("Order saved with ID:", newOrderRef.key);

    if (orderData && orderData.email) {
      const emailItems = (orderData.products || [])
        .map((item) => {
          const itemName =
            item.productName || item.name || item.productId || "Item";
          const itemQty = item.quantity != null ? item.quantity : 1;
          return `--- ${itemName} x ${itemQty}`;
        })
        .join("\n");

      const emailParams = {
        name: orderData.clientName || "",
        order_id: newOrderRef.key,
        email: orderData.email,
        total: `${orderData.total ?? 0} DA`,
        items: emailItems,
      };

      try {
        initEmailJs();
        await emailjs.send(
          "service_unh79hr",
          "template_gq33ipr",
          emailParams,
        );
        console.log("Confirmation email sent.");
      } catch (emailError) {
        console.error(
          "Email failed but order is saved. Error:",
          emailError,
        );
      }
    } else {
      console.warn("Order saved without email. Confirmation email not sent.");
    }
    return newOrderRef;
  } catch (error) {
    console.error("Error saving order:", error);
    throw new Error("Could not save order");
  }
};

export const incrNumberSales =  async(productId)=> {
    console.log("incr " + productId);
  try {
    // Reference to the product's numberSales property in the database
    const productRef = ref(database, `products/${productId}/numberSales`);

    console.log("incr before");

    // Retrieve the current number of sales
    const snapshot = await get(productRef);

    console.log("incr after");
    let updatedSales;
    if (snapshot.exists()) {
      // Increment existing numberSales value
      const currentSales = snapshot.val();
      updatedSales = currentSales + 1;
      console.log("incr...." + updatedSales);
    } else {
      // Initialize numberSales to 1 if it doesn't exist
      updatedSales = 1;
      console.log("incr...." + updatedSales);
    }

    // Update the numberSales in the database
    await update(ref(database, `products/${productId}`), {
      numberSales: updatedSales,
    });

    console.log(
      `Product ${productId} sales updated successfully to ${updatedSales}`
    );
  } catch (error) {
    console.error("Error incrementing product sales:", error);
  }
}


export const getReviewsById = async (idProduct) => {
    try {
      // Reference to the reviews collection in the database
      const reviewsRef = ref(database, "reviews");
      const snapshot = await get(reviewsRef);
  
      if (snapshot.exists()) {
        const reviewsData = snapshot.val();
        // Filter reviews by associatedProduct to match the given product ID
        const filteredReviews = Object.keys(reviewsData)
          .filter((key) => reviewsData[key].associatedProduct === idProduct)
          .map((key) => ({
            id: key,
            ...reviewsData[key],
          }));
  
        return filteredReviews;
      } else {
        console.log("No reviews found for the specified product");
        return [];
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      throw new Error("Could not fetch reviews");
    }
  };


  export const saveReview = async (reviewData) => {
    try {
      const newReviewRef = push(ref(database, "reviews")); // Create a new reference for the review
  
      // Prepare the review data with default values
      const reviewWithDefaults = {
        rating: 5,
        status: false,
        ...reviewData,
      };
  
      await set(newReviewRef, reviewWithDefaults); // Save review data to that reference
  
      console.log("Review saved with ID:", newReviewRef.key);
      return newReviewRef;
    } catch (error) {
      console.error("Error saving review:", error);
      throw new Error("Could not save review");
    }
  };


  export const getOrdersByUserId = async (userId) => {
    console.log("orders by user")
    try {
      

      console.log("userId from Utils : " + userId)
      const ordersRef = ref(database, `orders`);
      const snapshot = await get(ordersRef);

      if (snapshot.exists()) {
        const ordersData = snapshot.val();
        const userOrders = Object.keys(ordersData)
          .filter((key) => ordersData[key].clientId === userId)
          .map((key) => ({
            id: key,
            ...ordersData[key],
          }));

          
        console.log("orders found for the user" + userOrders );
        return userOrders;
      } else {
        console.log("No orders found for the user");
        return [];
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      throw new Error("Could not fetch orders");
    }
  };
  

  
  
const categoriesRef = ref(database , "productCategories");
const subcategoriesRef = ref(database , "productSubCategories");



const contentRef = ref(database, "Content-management");
export const getActiveContent = (callback) => {
  try {
    const unsubscribe = onValue(contentRef, (snapshot) => {
      if (snapshot.exists()) {
        const activeContentData = snapshot.val();
        callback(activeContentData);
      } else {
        console.log("No Content");
        callback({});
      }
    }, (error) => {
      console.error("Error fetching Contents:", error);
    });

    return unsubscribe;
  } catch (error) {
    console.error("Error setting up real-time listener:", error);
    throw new Error("Could not set up real-time listener");
  }
};




export const getAllCategories = async () => {
  try {
    const categoriesSnapshot = await get(categoriesRef);
    const subcategoriesSnapshot = await get(subcategoriesRef);

    if (categoriesSnapshot.exists() && subcategoriesSnapshot.exists()) {
      const categoriesData = categoriesSnapshot.val();
      const subcategoriesData = subcategoriesSnapshot.val();
      
      const categoriesList = Object.entries(categoriesData).map(([categoryId, category]) => {
        return {
          id: categoryId,
          ...category,
          subcategories: Object.entries(subcategoriesData)
            .filter(([_, subcategory]) => subcategory.category === categoryId)
            .map(([subcatId, subcategory]) => ({ id: subcatId, ...subcategory })),
        };
      });

      return categoriesList;
    } else {
      console.log("No categories or subcategories found");
      return [];
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw new Error("Could not fetch categories");
  }
};



export const saveWarrantyClaim = async (formData) => {
  try {
    console.log(formData);
    const newClaimRef = push(warrantyClaimsRef);
    await set(newClaimRef, {
      invoiceNumber: formData.invoiceNumber,
      purchaseDate: formData.purchaseDate,
      productType: formData.productType,
      productName: formData.productName,
      phoneNumber: formData.phoneNumber,
      contactEmail: formData.contactEmail,
      isUnderWarranty: formData.underWarranty,
      warrantyCertificate: formData.warrantyCertificate ? [formData.warrantyCertificate] : null,
      invoiceFile: formData.invoiceFile ? [formData.invoiceFile] : null,
    });
    console.log("Warranty claim saved with ID:", newClaimRef.key);
    return newClaimRef;
  } catch (error) {
    console.error("Error saving warranty claim:", error);
    throw new Error("Could not save warranty claim");
  }
};


export const uploadFileToStorage = async (file, folder) => {
  const formData = new FormData();
  formData.append("file", file); // file is expected to be a File object

  try {
    const response = await fetch("https://67732beecca8.ngrok-free.app/upload", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed with status ${response.status}`);
    }

    const result = await response.json();
    // Assume your server returns the uploaded file URL in a property like `url`
    return result.url
  } catch (error) {
    console.error("Error uploading file:", error);
    return null;
  }
}
